import { API_BASE_URL, apiClient, authenticatedApiClient } from '../config';

// Cache for blob URLs to avoid refetching
const imageBlobCache = new Map();

// Fetch image as blob and create blob URL
// This allows us to handle authenticated image requests
export const fetchImageAsBlob = async (imageId) => {
  if (!imageId) return null;
  
  // Check cache first
  if (imageBlobCache.has(imageId)) {
    return imageBlobCache.get(imageId);
  }

  try {
    // Try authenticated request first for images that might need auth
    let response;
    try {
      response = await authenticatedApiClient.get(`/assets/${imageId}`, {
        responseType: 'blob',
      });
    } catch (authError) {
      // If authenticated request fails, try without credentials
      console.warn(`Authenticated image fetch failed for ${imageId}, trying without credentials:`, authError);
      response = await apiClient.get(`/assets/${imageId}`, {
        responseType: 'blob',
      });
    }
    
    // Check if response is actually a blob (not an error)
    if (response.data instanceof Blob && response.data.size > 0) {
      const blobUrl = URL.createObjectURL(response.data);
      imageBlobCache.set(imageId, blobUrl);
      console.log(`Successfully created blob URL for ${imageId}:`, blobUrl);
      return blobUrl;
    } else {
      throw new Error('Response is not a valid blob');
    }
  } catch (error) {
    const status = error.response?.status;
    const statusText = error.response?.statusText;
    console.error(`Error fetching image ${imageId}:`, {
      status,
      statusText,
      message: error.message,
      fullError: error
    });
    
    if (status === 403 || status === 401) {
      console.warn(`Image ${imageId} requires authentication (${status}). Server needs to allow public asset access or provide API credentials.`);
    }
    
    // Return null so we can use fallback
    return null;
  }
};

// Construct image URL from image ID
export const getImageUrl = (imageId) => {
  if (!imageId) return null;
  // Directus assets endpoint
  // If images return 403, you may need to configure Directus to allow public asset access
  // Or use fetchImageAsBlob() to fetch with authentication
  return `${API_BASE_URL}/assets/${imageId}`;
};

